import Vue from "vue";

const modulo_facturas = {
    strict: false,

    state: {
        total: 0,
        factura: null,
    },
    mutations: {
        setTotal(state, nuevoTotal) {
            state.total = nuevoTotal;
        },
        setFactura(state, factura) {
            state.factura = factura;
        },
    },

    getters: {
        getTotal: (state) => state.total,
        getFactura: (state) => state.factura,
        // getclientes: (state) => state.clientes,
        // getmetodoscliente: (state) => state.metodos_pago,
    },

    actions: {
        updateTotal({ commit }, nuevoTotal) {
            commit("setTotal", nuevoTotal);
        },
        setFactura({ commit }, factura) {
            commit("setFactura", factura);
        },
        clearFactura({ commit }) {
            commit("setFactura", {});
        },
        // getClientes: (context, vm) => {
        //     axios.get("api/get-clientes/15?page=1").then(
        //         (res) => {
        //             context.commit("get_clientes", res.data.Clientes);
        //         },
        //         (res) => {}
        //     );
        // },
        // getClientesWithId: (context, vm) => {
        //     axios.get(`api/get-clientes/15?page=1&cliente=${vm.id}`).then(
        //         (res) => {
        //             context.commit("get_clientes", res.data.Clientes);
        //         },
        //         (res) => {}
        //     );
        // },
        // getClientesNext: (context, vm) => {
        //     axios
        //         .get(`api/get-clientes/15?page=${context.state.page ?? 1}`)
        //         .then(
        //             (res) => {
        //                 context.commit("update_clientes", res.data.Clientes);
        //             },
        //             (res) => {}
        //         );
        // },
        // searchCliente: (context, vm) => {
        //     axios
        //         .get(`api/get-clientes/15?page=1${vm ? `&busqueda=vm` : ""}`)
        //         .then(
        //             (res) => {
        //                 context.commit("update_clientes", res.data.Clientes);
        //             },
        //             (res) => {}
        //         );
        // },
        // getDataCliente(context, vm) {
        //     axios.get(`api/getcliente/${vm}`).then(
        //         (res) => {
        //             context.commit("get_data_cliente", res.data);
        //         },
        //         (res) => {}
        //     );
        // },
    },
};

export default modulo_facturas;
